import { formatDisplayTitle } from '../formatProductTitle';
import {
  MAX_GIFT_GROUPS,
  MAX_GIFT_RECIPIENTS,
  parseSlugList,
  slugifyGiftId,
} from '../giftFinder/giftFinderGroups';

export function normalizeGiftGroup(item, index) {
  if (!item || typeof item !== 'object') return null;
  const id = slugifyGiftId(item.id || item.slug, `group-${index + 1}`);
  const label = String(item.label || '').trim() || formatDisplayTitle(id.replace(/-/g, ' '));
  return {
    id,
    label,
    hint: String(item.hint || '').trim(),
    icon: String(item.icon || '·').trim() || '·',
    categories: parseSlugList(item.categories),
    subcategories: parseSlugList(item.subcategories),
    types: parseSlugList(item.types),
    tags: parseSlugList(item.tags),
  };
}

export function normalizeGiftRecipient(item, index) {
  if (!item || typeof item !== 'object') return null;
  const id = slugifyGiftId(item.id || item.slug, `recipient-${index + 1}`);
  const label = String(item.label || '').trim() || formatDisplayTitle(id.replace(/-/g, ' '));
  return {
    id,
    label,
    hint: String(item.hint || '').trim(),
    icon: String(item.icon || '·').trim() || '·',
    category: String(item.category || 'any').trim().toLowerCase() || 'any',
    group: String(item.group || '').trim().toLowerCase(),
    group_ids: parseSlugList(item.group_ids),
  };
}

export function normalizeGiftGroupsList(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .slice(0, MAX_GIFT_GROUPS)
    .map((item, i) => normalizeGiftGroup(item, i))
    .filter(Boolean);
}

export function normalizeGiftRecipientsList(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .slice(0, MAX_GIFT_RECIPIENTS)
    .map((item, i) => normalizeGiftRecipient(item, i))
    .filter(Boolean);
}
